import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function Authentication() {
  const { dataDetailUser } = useSelector((state) => state.pageBase);
  const navigate = useNavigate();
  useEffect(() => {
    if (dataDetailUser.permitions.length > 0) {
      if (
        dataDetailUser.permitions.some(
          (permission) => permission.path === '/price'
        )
      ) {
        navigate('/price');
      } else {
        navigate(dataDetailUser.permitions[0].path);
      }
    }
  }, [dataDetailUser]);

  return null;
}
